import { SiteArchivingRequestStatus, SiteStatus } from '@csp/csp-common-model';

export type ArchivingSitesQueryFilterCriteria = {
  siteStatus: SiteStatus[];
  requestStatus: SiteArchivingRequestStatus[];
};

export type PartialArchivingSitesQueryFilterCriteria = Partial<ArchivingSitesQueryFilterCriteria>;

export const EMPTY_ARCHIVING_SITES_QUERY_FILTER_CRITERIA: ArchivingSitesQueryFilterCriteria = {
  siteStatus: [],
  requestStatus: [],
};
